export default "__VITE_ASSET__BqHyJaWr__"